@use '@/styles/tokens' as *;

// Figma node 219:327388 — heading + range select, the chart, then a three-column summary.

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-5);
  border: 1px solid var(--border-subtle);
  border-radius: $radius-xl;
  background: var(--surface-card);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

// Title over the headline average, so §3's "prominently displayed" average sits with the chart
// rather than only in the §4 summary row underneath it.
.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-20;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  color: var(--text-primary);
}

.unit {
  font-family: $font-family-base;
  font-size: $font-size-13;
  font-weight: $font-weight-regular;
  color: var(--text-muted);
}

.average {
  display: flex;
  align-items: baseline;
  gap: var(--space-1);
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-24;
  font-weight: $font-weight-medium;
  line-height: 1.1;
  color: var(--text-primary);
}

.averageUnit {
  font-family: $font-family-base;
  font-size: $font-size-13;
  font-weight: $font-weight-regular;
  color: var(--text-muted);
}

.range {
  flex: none;
  width: 120px;
}

.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  min-height: 240px;
}

.stateText {
  margin: 0;
  font-size: $font-size-14;
  line-height: 1.4;
  color: var(--text-muted);
  text-align: center;
}

.skeleton {
  min-height: 240px;
  border-radius: $radius-lg;
  background: linear-gradient(90deg, $color-neutral-100, $color-neutral-200, $color-neutral-100);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

.summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  margin: 0;
}

.summaryItem {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.summaryLabel {
  font-size: $font-size-13;
  line-height: 1.3;
  color: var(--text-muted);
}

.summaryValue {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-24;
  font-weight: $font-weight-medium;
  line-height: 1.1;
  color: var(--text-primary);
}

.summaryUnit {
  font-family: $font-family-base;
  font-size: $font-size-13;
  font-weight: $font-weight-regular;
  color: var(--text-muted);
}
